module.exports = __webpack_public_path__ + "static/media/DSC_0238.09ff85a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0238.jpg
// module id = 651
// module chunks = 0